import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { Response } from 'src/app/services/models/response.model'
import { Sim } from './models/sim/sim.model';
import { SimStock } from './models/sim/simstock.model';

@Injectable()
export class SimService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.portaccount;
  }

  getAll(Status: number, PhoneNumber: string, SimType: number): Observable<Response<Sim[]>> {
   
    let url = `/GetAllPortAccount`;
    return this.get(url)
      .map(result => new Response<Sim[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  search(Status: number, PhoneNumber: string, SimType: number): Observable<Response<Sim[]>> {

    let url = `/SearchPortAccount`;
    return this.post(url, {
      PortAccountName: PhoneNumber,
      Status: Status
    })
      .map(result => new Response<Sim[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  searchStock(FromDate: Date, ToDate: Date, Status: number): Observable<Response<SimStock[]>> {

    let url = `/PortAccountStock`;
    return this.post(url, {
      FromDate,
      ToDate,
      Status
    })
      .map(result => new Response<SimStock[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }
};
